import throttle from 'lodash.throttle';
import g from '#core/global';
import load from '#core/load';
import layout from '#core/layout';


const module_name = 'photo-stack';
const state = window.teal_state = window.teal_state || {};
state.photo_stack = state.photo_stack || {};

const stack_$ = '.photo-stack';
const delay_attr = 'data-delay';
const lookaround_attr = 'data-lookaround';
const is_active_attr = 'data-is-active';
const true_s = 'true';
const false_s = 'false';

let has_photo_stack = false;
let $stacks = [];


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran(module_name)) return false;
		
		load.content(() => {
			has_photo_stack = assign_elements();
			if (!has_photo_stack) return false;
		});
		load.all(() => {
			has_photo_stack = assign_elements();
			if (!has_photo_stack) return false;
			
			assign_scroll_events();
			check_stacks();
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_photo_stack) return true;
	
	$stacks = document.querySelectorAll(stack_$);
	if (!$stacks.length) return false;
	
	return true;
}


/**
 * Assign scroll events
 */
function assign_scroll_events() {
	window.addEventListener(g.scroll_e, throttle(() => {
		check_stacks();
	}, 250));
}


/**
 * Check if any stacks are intersecting
 */
function check_stacks() {
	$stacks.forEach($stack => {
		if ($stack.getAttribute(is_active_attr) === true_s) return false;
		
		const is_intersecting = layout.isIntersecting({
			$element: $stack,
			lookaround: parseFloat($stack.getAttribute(lookaround_attr)),
		});
		if (!is_intersecting) return false;
		
		$stack.setAttribute(is_active_attr, true_s);
	});
}
